import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar/Sidebar';
import TopBanner from '../components/Dashboard/TopBanner';

const DashboardLayout = () => {
  return (
    <div className="flex flex-col w-full h-screen overflow-hidden">
      {/* Top Banner */}
      <div className="bg-bg h-16 w-full flex items-center justify-between px-4 border-b border-gray-200 shadow-md">
        <TopBanner />
      </div>

      <div className="flex flex-1 w-full h-full overflow-hidden ">
        {/* Sidebar */}
        <div className="bg-bg h-full w-auto  flex-shrink-0 border-r border-gray-200 shadow-md">
          <Sidebar />
        </div>

        {/* Dynamic Content */}
        <div className="flex-1 px-4 md:px-8 lg:px-20 py-4 md:py-6 lg:py-8 bg-bg-Dashboard w-full lg:w-[87.01%] h-full overflow-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;